import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { museumApi } from "../../../services/MuseumServices";

function ReportFilters({ setMuseumId }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const [museums, setMuseums] = useState([]);

  useEffect(() => {
    getMuseumList();
  }, []);

  const getMuseumList = () => {
    museumApi("get").then((response) => {
      setMuseums(response?.data);
    });
  };

  return (
    <div className="ticket-filter-container">
      <Grid container spacing={1} alignItems="center">
        {user?.username === "admin" && (
          <>
            <Grid item lg={3.5} xs={8}>
              <Autocomplete
                id="combo-box-demo"
                options={museums}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => {
                  setMuseumId(value?.id);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Choose museum"
                    label="Select Museum"
                    name="museum_ids"
                    size="small"
                  />
                )}
                fullWidth
                size="small"
                sx={{ height: "40px" }}
              />
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
}

export default ReportFilters;
